import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUaFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52832)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M0.000488281 25H50.0004V40.5173C50.0004 40.9933 49.6144 41.3794 49.1383 41.3794H0.862596C0.386523 41.3794 0.000488281 40.9933 0.000488281 40.5173V25Z",
				fill: "#FFE15A"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M50.0004 24.9995H0.000488281V9.48222C0.000488281 9.00615 0.386523 8.62012 0.862596 8.62012H49.1384C49.6145 8.62012 50.0005 9.00615 50.0005 9.48222L50.0004 24.9995Z",
				fill: "#4173CD"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52832",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUaFlag);
export { ForwardRef as ReactComponent };
